import type { LotStoryProjectionReadiness } from '../../types/lotStory'

export type LotStoryReadinessCueLevel = 'strong' | 'caution' | 'weak'

export type LotStoryReadinessCueReason =
  | 'fully-ready'
  | 'has-blocking-readiness-reasons'
  | 'pending-lineage-sync'
  | 'ambiguous-legacy-matches'
  | 'source-data-stale'
  | 'has-warning-readiness-reasons'
  | 'unresolved-evidence'
  | 'source-freshness-unknown'

export type LotStoryReadinessCue = {
  level: LotStoryReadinessCueLevel
  reason: LotStoryReadinessCueReason
}

const isPositive = (value: unknown): boolean => typeof value === 'number' && Number.isFinite(value) && value > 0

export const deriveLotStoryReadinessCue = (readiness: LotStoryProjectionReadiness): LotStoryReadinessCue => {
  if (readiness.status === 'blocked') {
    return { level: 'weak', reason: 'has-blocking-readiness-reasons' }
  }
  if (readiness.pendingLineageSync) {
    return { level: 'weak', reason: 'pending-lineage-sync' }
  }
  if (isPositive(readiness.ambiguousLegacyMatchCount)) {
    return { level: 'weak', reason: 'ambiguous-legacy-matches' }
  }
  if (readiness.sourceFreshness === 'stale') {
    return { level: 'weak', reason: 'source-data-stale' }
  }
  if (readiness.status === 'warning') {
    return { level: 'caution', reason: 'has-warning-readiness-reasons' }
  }
  if (isPositive(readiness.unresolvedEvidenceCount)) {
    return { level: 'caution', reason: 'unresolved-evidence' }
  }
  if (readiness.sourceFreshness === 'unknown') {
    return { level: 'caution', reason: 'source-freshness-unknown' }
  }
  return { level: 'strong', reason: 'fully-ready' }
}
